module.exports = __webpack_public_path__ + "static/media/logo-engager-inverse.8fb722cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-engager-inverse.svg
// module id = 937
// module chunks = 0